import React from "react";
import CapsuleImageVertical from "../CapsuleImageVertical/CapsuleImageVertical";
import TemporaryLifeImage from "../../Assets/Images/temporary-life.png";
import { Container } from "reactstrap";
import SectionTwoImageMobile from "../../Assets/Images/Our Products-2-Mob.png";
import wardsImage from "../../Assets/Images/wards.png";
import { Link } from "react-router-dom";
import { useTranslation } from "../../Hooks/useTranslation";

const TermLife = ({ isScrollable, sectionActive }) => {
  const translations = useTranslation(); // Get translations dynamically
  return (
    <>
      <div
        className={`${!isScrollable ? "item" : ""} ${
          sectionActive ? "active-container" : ""
        }`}
      >
        <div className="w-full flex  gap-8 lg:flex-row flex-col-reverse justify-between lg:items-end xl:items-center">
          <div className="mt-2 mb-4 lg:pl-0 pl-4 our-prod-tab-content  max-w-[408px]">
            <div className="lg:h-[230px] [@media(min-width:1920px)]:h-[345px] lg:mt-[62px] [@media(min-width:1920px)]:mt-[98px] lg:flex lg:flex-col lg:justify-end lg:gap-4 [@media(min-width:1920px)]:gap-6">
              <h2
                className="text-[24px] leading-[28px] lg:text-[34px] lg:leading-[37px] [@media(min-width:1920px)]:text-[51px] [@media(min-width:1920px)]:leading-[55.5px] tracking-[-0.02em] font-semibold mb-4 lg:mb-0 product-headline"
                id="TermLife"
              >
                {translations.termLifeHeading}
              </h2>
              <p className=" text-[14px] leading-[22px] mb-3 lg:mb-0 lg:h-[66px] [@media(min-width:1920px)]:h-[99px] [@media(min-width:1920px)]:leading-[33px] extra-para-vs">
                {translations.termLifeDescription}
              </p>
            </div>
            <div className="flex gap-2 lg:mt-6 mt-4 product-buttons">
              <Link
                to="/term-life-insurance"
                className="inline-flex items-center justify-center gap-1.5 h-[30px] pl-3 pr-[18px] text-[12px] [@media(min-width:1920px)]:h-[45px] [@media(min-width:1920px)]:pl-5 [@media(min-width:1920px)]:pr-7 [@media(min-width:1920px)]:text-[16px] [@media(min-width:1920px)]:gap-2 font-medium rounded-full border border-[#999999] border-solid text-[#999999] hover:bg-[#0D4248] hover:border-[#0D4248] hover:text-white transition-colors"
              >
                <svg className="w-3 h-3 [@media(min-width:1920px)]:w-[18px] [@media(min-width:1920px)]:h-[18px]" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M12 6.75H6.75V12H5.25V6.75H0V5.25H5.25V0H6.75V5.25H12V6.75Z" />
                </svg>
                {translations.productMoreButton}
              </Link>
              <Link
                to="/compare-plans"
                className="inline-flex items-center justify-center h-[30px] px-[18px] text-[12px] [@media(min-width:1920px)]:h-[45px] [@media(min-width:1920px)]:px-7 [@media(min-width:1920px)]:text-[16px] font-medium rounded-full border border-[#999999] border-solid text-[#999999] hover:bg-[#0D4248] hover:border-[#0D4248] hover:text-white transition-colors"
              >
                {translations.productCompareButton}
              </Link>
            </div>
          </div>
          <div className="product-right-img lg:-mt-[80px] xl:mt-0">
            <div className="hidden lg:block">
              <img src={TemporaryLifeImage} alt="Temporary Life" />
            </div>
            <div className="mt-4 -mr-4 md:mr-0 md:pl-4 lg:hidden flex md:max-w-[664px] overflow-hidden md:overflow-visible">
              <img
                src={SectionTwoImageMobile}
                alt="section-two-image-mobile"
                className="w-[130%] md:w-full max-w-none md:max-w-full"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermLife;
